import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';


export class SenderVarsPage extends React.Component {

    state = {
        
        items : []
        
    }

    constructor(props) {
        super(props);
        
    }

    
    componentDidMount() {
        
       const cookies = new Cookies();
       axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetSenderVarsTg', {
                   headers: {
                   'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                   }
               }).then(res => {
                   //projects = res.data.projects
                  
                   
                   
                       this.setState( {
                           
                           items : res.data.res
                       });
                  
                   

               })
               .catch(err => {
                   console.log(err);
                   

               })
       
       
    }    

    render() {
        return (
            <div>
               
                
                <div className="whiteBlock senderVarsWhiteBlock">
                        <div className='whiteBlockTitle'>
                    <BeautifulCircleIcon/> 
                    <div className="whiteBlockTitleSpan">
                        Выберите канал для рассылки:
                        </div>
                    </div>   
                    <div className="whiteBlockMiddle senderVarsBlock grayScroll">
                            {
                            this.state.items.map(item => {
                                return (
                                    <div  onClick={(e) => {
                                        
                                        this.props.chooseTgSenderAlias(e, item.alias, item.cnt)
                                    }} className={this.props.chosenAlias == item.alias ? "senderVarsPage_mainBlock__row senderVarsPage_mainBlock__row_chosen" : "senderVarsPage_mainBlock__row" } > 
                                        <div  className="senderVarsPage_mainBlock__row__img"><img src={item.big_img_src} /></div>
                                        <div className='senderVarsPage_mainBlock__row__name_and_subCnt'>
                                            
                                            <div  className="senderVarsPage_mainBlock__row__channel_name">
                                                Название канала: <span className="blue">{item.channel_name}</span></div>
                                            
                                            <div  className="senderVarsPage_mainBlock__row__name">
                                                Название виджета: <span className="blue">{item.widget_name}</span></div>
                                            <div  className="senderVarsPage_mainBlock__row__subCnt">
                                                Число подписчиков рассылки: <span className="blue">{item.cnt}</span> </div>
                                   
                                        </div>
                                        <a href='#' onClick={(e) => {
                                            
                                            
                                            this.props.chooseTgSenderAlias(e, item.alias, item.cnt)
                                        }} className='btn3'>
                                            Выбрать    
                                        </a>     
                                    </div>
                                );
                                })
                                }
                    </div>
                                
                    <div className='whiteBlockButtonBlock'>
                    <a href='#' onClick={(e) => {
                        this.props.handleClickSecondStage(e)
                    }} className='whiteBlockButton'>

                                        Далее
                                </a>

                </div>  
                </div>
                
                
               

            </div>
                 
        )
    }
    
}